import { useCallback } from "react";
import Tooltip from "~/components/analytics/shared/Tooltips/BasicTooltip";

export type DateFilter = "1hour" | "4hours" | "1day" | "7days" | "14days" | "28days";

type Props = {
  setFilter: (DateFilter) => void;
  filter: DateFilter;
  heading?: string;
  subHeading?: string;
  className?: string;
  tooltip?: {
    name: string;
    description: string;
  };
  hideDateFilter?: boolean;
};

export const DATE_FILTERS = [
  { label: "1h", value: "1hour" },
  { label: "4h", value: "4hours" },
  { label: "1d", value: "1day" },
  { label: "7d", value: "7days" },
  { label: "14d", value: "14days" },
  { label: "28d", value: "28days" },
];

// actually driven by Organization::ServiceQuotas::TestEngineMaxTimeWindow, not a feature flag
if (Features.AnalyticsTagging90DaysView) {
  DATE_FILTERS.push({ label: "90d", value: "90days" });
}

const DateFilters = ({
  className,
  heading,
  subHeading,
  tooltip,
  filter,
  hideDateFilter,
  setFilter,
}: Props) => (
  <div
    className={`${className} flex justify-between max-[486px]:flex-col max-[486px]:items-start min-[487px]:items-center`}
  >
    {heading && <h2 className="charcoal-700 mt-4 text-lg">{heading}</h2>}

    {subHeading && (
      <div className="flex items-center">
        <h3 className="charcoal-700 text-sm">{subHeading}</h3>
        {tooltip && (
          <Tooltip classNames="ml-2" name={tooltip.name}>
            <>
              <p className="m-0 font-semibold">{subHeading}</p>
              <p className="m-0 mt-1" dangerouslySetInnerHTML={{ __html: tooltip.description }} />
            </>
          </Tooltip>
        )}
      </div>
    )}

    {!hideDateFilter && (
      <div className="inline-flex rounded border border-gray-500 bg-white p-0.5">
        {DATE_FILTERS.map((dateFilter) => {
          const isActive = filter === dateFilter.value;
          const handleClick = useCallback(() => setFilter(dateFilter.value), []);

          return (
            <button
              key={dateFilter.value}
              onClick={handleClick}
              className={`text-charcoal-700 focus:text-charcoal-700 flex cursor-pointer items-center rounded-sm px-2.5 py-1 text-sm font-medium hover:text-purple-600 hover:no-underline focus:no-underline focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-offset-2 ${isActive ? "bg-purple-100 text-purple-600 focus:text-purple-600" : ""}`}
            >
              {dateFilter.label}
            </button>
          );
        })}
      </div>
    )}
  </div>
);

export default DateFilters;
